import React , { useState ,  useEffect , useRef } from 'react';
import PropTypes from 'prop-types';
import './AboutUs.scss';
import AppImages from '../../Utils/ThemeImages';
import Marquee from 'react-fast-marquee';
import marqueeArrow  from '../../images/arrow-carousel-marqe.svg'
import ReUsable from '../Re-usable/ReUsable';
import TestimonialSlider from '../Re-usable/TestimonialSlider';
import OurTeam from '../Re-usable/OurTeam';
import { Helmet } from 'react-helmet';

const AboutUs = () => {


  const marqueeSlider = [
    {
      name: 'Port Handling'
    },
    {
      image: marqueeArrow
    },
    {
      name: 'Stevedoring'
    },
    {
      image: marqueeArrow
    },
    {
      name: 'Port Handling'
    },
    {
      image: marqueeArrow
    },
    {
      name: 'Transport'
    },
    {
      image: marqueeArrow
    },
    {
      name: 'Port Handling'
    },
    {
      image: marqueeArrow
    },
    {
      name: 'Stevedoring'
    },
    {
      image: marqueeArrow
    },
    {
      name: 'Port Handling'
    },
    {
      image: marqueeArrow
    },
    {
      name: 'Transport'
    },
    {
      image: marqueeArrow
    },
  ]

  const canonicalUrl = "https://whitetowerinternational.com/About-Us";


  const [openIndex, setOpenIndex] = useState(null); // To track which accordion is open
  const contentRefs = useRef([]); // Array of refs to track each accordion's content height

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index); // Toggle open/close based on index
  };

  const faqs = [
    { title: 'What is Stevedores ?', content: 'Stevedores are workers who oversee the loading and offloading of a cargo vessel at SEA ports. Commonly referred to as “dockers” or “dock workers,” stevedores must be highly skilled in loading/unloading, lashing, stowing and securing all types of cargos commodities. ' },
    { title: 'Can You Handle Heavy Lift?', content: 'Yes, we can obviously handle heavy left cargo, and also have experience of handling heavy lift cargo in port of Duqm (for DUQM OIL REFINARY) ' },
    { title: 'Do you offer Service assistance?', content: 'Yes, we offer comprehensive service assistance to ensure that your cargo handling needs are met efficiently.' },
    { title: 'What types of cargo do you handle?', content: 'Types of cargo handled by White Tower International LLC : Steel Pipes ,Steel Plates , Project Cargo , Container Vessel , Dolomite , Limestone , Copper Slag , Steel Coils , Fishing Boat , Explosive Material (Navy Vessel) , Rounds Blooms , Steel Rebar , Steel Square Billet , Steel Wires , Project Cargo , Limestone Bags , Scraps , Bulk Cargo , Dolomite Bags' }
  ];

  useEffect(() => {
    faqs.forEach((_, index) => {
      if (openIndex === index && contentRefs.current[index]) {
        contentRefs.current[index].style.maxHeight = `${contentRefs.current[index].scrollHeight}px`;
      } else if (contentRefs.current[index]) {
        contentRefs.current[index].style.maxHeight = '0px';
      }
    });
  }, [openIndex]);



  return (
    <div className="AboutUs">
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>White Tower - About Us</title>
      </Helmet>
      <div className="about-us-main-inner-section">
        <section className="about-section-1">
          <div className="inner-about-section-1">
            <div className="container">
              <div className="about-banner-head-sec-1">
                <h1>ABOUT US</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="about-section-2">
          <div className="inner-about-section-2">
            <div className="container">
              <div className="about-section-2-heading wow animate__animated animate__fadeInDown">
                <h2>ABOUT OUR COMPANY</h2>
              </div>
              <div className="grid grid-cols-2 gap-10">
                <div className="about-sec-2-left wow animate__animated animate__fadeInLeft">
                  <img src={AppImages.aboutWhiteTower} className='h-full object-cover' alt="" />
                </div>
                <div className="about-sec-2-right wow animate__animated animate__fadeInRight">
                  <div className="top-mini-head-seciton-2">
                    <h4>WHITE TOWER INTERNATIONAL LLC</h4>
                  </div>
                  <div className="bottom-right-sec-2-para-about">
                    <p>WHITE TOWER INTERNATIONAL LLC is a reputable sub-contractor operating at SOHAR PORT (OMAN), JINDAL SHADEED IRON & STEEL OMAN, PORT OF DUQM OMAN, SOHAR STEEL OMAN , for over a decade. With a commitment to excellence and a wealth of experience in the industry, the team provides a range of services to support the smooth functioning of the port and its associated infrastructure projects. The company has gained a strong reputation for its professionalism, expertise, and dedication to delivering high-quality results.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="about-section-3">
          <div className="inner-about-section-3">
            <div className="container">
              <div className="about-section-3-heading wow animate__animated animate__fadeInDown">
                <h2>OUR GOALS</h2>
              </div>
              <div className="grid grid-cols-2 gap-10">
                <div className="about-sec-3-right wow animate__animated animate__fadeInLeft">
                  <div className="bottom-right-sec-3-para-about">
                    <p>Our mission is to provide exceptional cargo handling services while prioritizing safety and efficiency. We aim to continuously improve our operations by investing in innovative technologies and training our employees. By fostering strong relationships with our clients and stakeholders, we seek to establish ourselves as the trusted partner for all logistics needs, enhancing overall supply chain performance in the industry.</p>
                    {/* <p>That's  why  we  are committed to completing every project on time and within budget.We thrive to work with owners and engineers to help get projects in budget and completed on time.We work closely together with soil engineers to achieve the highest level of quality.Our goal is to help you achieve your goals.</p> */}
                  </div>
                </div>
                <div className="about-sec-3-left wow animate__animated animate__fadeInRight">
                  <img src={AppImages.ourGoals} className='h-full object-cover' alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="about-section-4">
          <div className="inner-about-section-4">
            <Marquee
                gradient={false}
                gradientColor={'#181818'}
                gradientWidth={200}
                pauseOnHover
            >
              {marqueeSlider.map((items , index) => {
                return (
                  <div className="content-marquee" key={index}>
                    {items.name ? <div className='marquee-item-name-section'><h4>{items.name}</h4></div> : null}
                    {items.image ? <div className='marquee-item-image-section'><img src={items.image} alt="" /></div> : null}
                  </div>
                )
              })}
            </Marquee>
          </div>
        </section>
        <OurTeam/>
        <section className="about-section-6">
          <div className="inner-about-section-6">
            <div className="container">
              <div className="about-sec-6-faqs">
                <div className="about-sec-6-heading wow animate__animated animate__fadeInLeft">
                  <h2>F.A.Q'S</h2>
                </div>
                <div className="bottom-absec-6-faq-section">
                  {faqs.map((faq, index) => (
                    <div className="about-accordion wow animate__animated animate__fadeInUp" key={index}>
                      <div className="about-accordion-header flex justify-between items-center" onClick={() => toggleAccordion(index)}>
                        <h2><span className='opacity-45'>0{index + 1} . </span>{faq.title}</h2>
                        <div className={`right-button h-6 w-6 relative  ${openIndex === index ? 'activer-plus' : ''}`}>
                          <div className={`plus-icon-1 w-full h-[2px] bg-white absolute top-1/2 left-1/2 `}></div>
                          <div className={`plus-icon-2 w-[2px] h-full bg-white absolute left-1/2 top-1/2 ${openIndex === index ? 'activer-plus' : ''}`}></div>
                        </div>
                      </div>
                      <div ref={(el) => (contentRefs.current[index] = el)} className="about-accordion-content" style={{ maxHeight: openIndex === index ? `${contentRefs.current[index]?.scrollHeight}px` : '0px' }}>
                        <p>{faq.content}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <TestimonialSlider/>
      </div>
    </div>
  );
}




AboutUs.propTypes = {};

AboutUs.defaultProps = {};

export default AboutUs;
